import { Component, Element, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-chat",
    styleUrl: "chat.scss",
    shadow: true
})
export class Chat {
    @Element() el!: HTMLUxChatElement;

    /**
     * Indicates if chat partner is currently typing.
     */
    @Prop() readonly typing?: string;

    componentDidLoad() {
        // No need for manual scroll management
    }

    render() {
        return (
            <Host>
                <div id="chat-container">
                    <div id="items" role="list" aria-live="polite">
                        <slot></slot> {/* Default slot for ux-chat-item components */}
                        {this.typing && <ux-chat-typing-indicator text={this.typing}></ux-chat-typing-indicator>}
                    </div>
                </div>
                <div id="chat-bar">
                    <slot name="bar"></slot> {/* Named slot for ux-chat-message-bar component */}
                </div>
            </Host>
        );
    }
}
